/** Watch rules for long Vantage jobs. Person runs routinely exceed 90 minutes. */

export const RESEARCH_WATCH_UNREACHABLE_MS = 45 * 60 * 1000;

export type ResearchWatchDecision = {
  fail: boolean;
  reason: 'still_running' | 'session_expired' | 'unreachable' | null;
};

export function decideResearchWatchFailure(args: {
  nowMs: number;
  lastSuccessAtMs: number;
  lastHttpStatus?: number | null;
}): ResearchWatchDecision {
  if (Number(args.lastHttpStatus || 0) === 401) {
    return { fail: false, reason: 'session_expired' };
  }
  if (args.nowMs - args.lastSuccessAtMs < RESEARCH_WATCH_UNREACHABLE_MS) {
    return { fail: false, reason: 'still_running' };
  }
  return { fail: true, reason: 'unreachable' };
}
